import React, { useEffect, useState, useMemo } from 'react'
import { Spin } from 'antd'
import { useNavigate } from 'react-router-dom'
import qs from 'qs'
import Modal from 'meinian-package/src/baseComponent/modal'
import request from 'meinian-package/src/utils/request'
import Icon from 'meinian-package/src/component/icon'
import sortBy from 'lodash/sortBy'
import { getIpadVh } from 'common/ipad'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import classNames from 'classnames'
import { useRequest } from 'ahooks'
import util from 'meinian-package/src/utils/util'
import getBoxLabelRetList from '../../../common/getBoxLabelRetList'
import OperationView from './operationView'
import InfoView, { IMAGE_DETAIL_TAB } from './infoView'
import Recommend from './infoView/recommend'
import { ImageDetailContext } from './content'
import Guide from './guide'
import getInfo from '../../../component/imageAction/getInfo'
import type { IQueryParams, TCurrentImageInfo } from './interface'
import type { IImageDetailContext } from './content'
import styles from './index.module.less'

export type ModalImageDetailProps = {
  list?: Array<any>,
  onChangeIndex?: (arg:number)=>void,
  maxListLength:number,
  onChange?: (success:boolean, newItemData:any)=>void,
  initWaterfall?:any,
  initSubColls?:any,
  visible: boolean,
  onVisibleChange: (val:boolean)=>void,
  onDeleteItem?:any,
}

export default ({
  list,
  visible,
  maxListLength,
  onChangeIndex,
  onChange,
  initWaterfall,
  initSubColls,
  onVisibleChange,
  onDeleteItem
}: ModalImageDetailProps) => {
  return <Modal
    visible={visible}
    style={{ width: '100vw', height: '100%', borderRadius: 0, overflow: 'hidden', background: '#fff' }}
    hiddenFooter
    className={styles.mnImageDetail}
    hiddenCloseIcon
  >
    <DetailContent
      list={list}
      maxListLength={maxListLength}
      onChangeIndex={onChangeIndex}
      onChange={onChange}
      initWaterfall={initWaterfall}
      initSubColls={initSubColls}
      onDeleteItem={onDeleteItem}
      type="modal"
      onVisibleChange={onVisibleChange}
    />
  </Modal>
}

export const DetailContent = ({
  list = [],
  onChangeIndex,
  maxListLength = 0,
  onChange,
  initWaterfall,
  initSubColls,
  onDeleteItem,
  onVisibleChange,
  type = null
}: Omit<ModalImageDetailProps, 'visible'> & { type?:string }) => {
  const isPage = type !== 'modal'
  const navigate = useNavigate()
  const query:any = qs.parse(location.search, { ignoreQueryPrefix: true })
  const [currentIndexInList, setCurrentIndexInList] = useState(list.findIndex(item => item.imageGroupEntityId === query.imageGroupEntityId))

  const queryParams: IQueryParams = {
    blogId: query.imageGroupEntityId,
    inspirationId: query.inspirationId,
    collectId: query.collectId,
    shareUrl: query.shareUrl
  }

  const [innerIndex, setInnerIndex] = useState<number>(0)
  const [banOperation, setBanOperation] = useState<boolean>(false) // 禁止操作
  const [tabValue, setTabValue] = useState<IMAGE_DETAIL_TAB>(IMAGE_DETAIL_TAB.INFO)
  const [boxIndex, setBoxIndex] = useState(0)

  const [isAnnotate, setIsAnnotate] = useState(false)
  const [activeNoteIndex, setActiveNoteIndex] = useState(0)
  const [showRight, setShowRight] = useState(false)
  const [isMove, setIsMove] = useState(false)

  const {
    data: upgradeInfo = {},
    run: runStyleImageInfo,
    loading: infoLoading
  } = useRequest(() => getInfo(queryParams.inspirationId as number, queryParams.blogId as string), {
    refreshDeps: [currentIndexInList]
  })

  const { data: imgInfoList = [], loading, run: runImgsData, mutate: setImgInfoList } = useRequest(async () => {
    const result:any = await request.get('/zhikuan/ins/inspiration/blog-detail', { params: {
      onlyClothes: 0,
      inspirationId: queryParams.inspirationId,
      shareUrl: queryParams.shareUrl,
      collectId: queryParams.collectId,
      blogId: queryParams.blogId,
    } })
    result.forEach((r) => {
      r.boxLabelRetList = getBoxLabelRetList(r.boxLabelRetList)
    })
    const _result = sortBy((result || []), ['rank'])
    setBoxIndex(0)
    return _result
  }, {
    refreshDeps: [currentIndexInList]
  })

  const currentImage: TCurrentImageInfo = useMemo(() => {
    return imgInfoList[innerIndex] || {}
  }, [innerIndex, imgInfoList])

  const { data: tags = [], run: runTag } = useRequest(() => request.get(`/zhikuan/img-tag/list-img-tag?entityId=${queryParams.blogId}`), {
    refreshDeps: [currentIndexInList]
  })

  const { data: commentTotal = 0, run: runCommentTotal } = useRequest(async () => {
    const res:number = await request.get('/zhikuan/ins/inspiration/exclude/count-user-comment', {
      params: {
        blogId: queryParams.blogId,
        collectOrSampleId: queryParams.collectId,
        type: 0,
      }
    })
    return res
  }, {
    refreshDeps: [currentIndexInList]
  })

  const { data: samples = {}, run: runSampleInfo } = useRequest(() => request.post('/zhikuan/mn/sample/query-sample-info', { blogId: queryParams.blogId, inspirationId: queryParams.inspirationId, collectId: queryParams.collectId }), {
    ready: teamHasAuth('meinian_sample_process'),
    refreshDeps: [currentIndexInList]
  })

  useEffect(() => {
    if (query.trackSourceType && isPage) {
      util.track('mn-style-detail-page', {
        module1: query.trackSourceType
      })
    }
  }, [])

  const onInit = () => {
    setInnerIndex(0)
    runCommentTotal()
    runImgsData()
    runTag()
    runSampleInfo()
    runStyleImageInfo()
  }

  const onOuterChange = (val: number) => {
    const cur = list[val]
    history.replaceState({}, '', `/meinian/detail/image?${qs.stringify({
      imageGroupEntityId: cur.imageGroupEntityId,
      inspirationId: cur.inspirationId,
      collectId: cur.collectId,
      shareUrl: queryParams.shareUrl,
    })}`)
    setCurrentIndexInList(val)
    onChangeIndex?.(val)
  }

  useEffect(() => {
    const onKeyDown = (e) => {
      if (banOperation) {
        return
      }
      if (e.keyCode === 38 && imgInfoList[innerIndex - 1]) {
        setInnerIndex(innerIndex - 1)
      }
      if (e.keyCode === 40 && imgInfoList[innerIndex + 1]) {
        setInnerIndex(innerIndex + 1)
      }
      // 外层
      if (e.keyCode === 37 && currentIndexInList - 1 >= 0 && tabValue !== IMAGE_DETAIL_TAB.RECOMMEND) {
        onOuterChange(currentIndexInList - 1)
      }
      if (e.keyCode === 39 && currentIndexInList + 1 < list.length && tabValue !== IMAGE_DETAIL_TAB.RECOMMEND) {
        onOuterChange(currentIndexInList + 1)
      }
    }
    window.addEventListener('keydown', onKeyDown)
    return () => {
      window.removeEventListener('keydown', onKeyDown)
    }
  }, [imgInfoList, innerIndex, banOperation, tabValue, currentIndexInList])

  useEffect(() => {
    if (query.commentId) {
      setTabValue(IMAGE_DETAIL_TAB.COMMENT)
    }
    if (query.postilId && currentImage?.mainUrl) {
      const _index = imgInfoList.findIndex((item) => item.id === query.postilId)
      if (_index !== -1) {
        setInnerIndex(_index)
      }
      setTabValue(IMAGE_DETAIL_TAB.ANNOTATION)
    }
  }, [currentImage?.mainUrl])

  const [notes, setNotes] = useState([])
  const { run: fetchNotes } = useRequest(async () => {
    const res:any = await request.post('/zhikuan/annotation/get-inspiration-blog-annotation', {
      mainUrl: currentImage?.mainUrl,
      targetId: queryParams.collectId,
    })
    if (res.baseBlogAnnotationDTOList) {
      setNotes(res.baseBlogAnnotationDTOList
        .map(m => ({ ...m, confirm: true, width: currentImage.width, height: currentImage.height })))
    }
  }, {
    ready: !!currentImage?.mainUrl,
    refreshDeps: [currentImage?.mainUrl]
  })

  const them: IImageDetailContext = useMemo(() => ({
    runImgsData,
    tabValue,
    onTabChange: (val) => setTabValue(val),
    currentImage,
    queryParams,
    onInit,
    initWaterfall: () => {
      initWaterfall?.()
      initSubColls?.()
    },
    onChange,
    setBanOperation,
    onVisibleChange,
    boxIndex,
    setBoxIndex,
    upgradeInfo,
    reload: runStyleImageInfo,
    onDeleteItem: () => {
      onDeleteItem(currentImage)
    },
    tags,
    samples,
    //
    isMove,
    setIsMove,
    commentTotal,
    onInitCommentTotal: runCommentTotal,
    // 批注
    notes,
    setNotes,
    onInitNotes: fetchNotes,
    activeNoteIndex,
    setActiveNoteIndex,
    isAnnotate,
    setIsAnnotate,
    showRight,
    setShowRight,
    isPage,
  }), [tabValue, currentImage, queryParams, upgradeInfo, isMove, boxIndex, tags, notes, activeNoteIndex, isAnnotate, isPage])

  return <ImageDetailContext.Provider value={them}>
    <Guide shareUrl={queryParams.shareUrl} />
    {
      !query?.from && <div
        className={classNames(styles.close, 'fill-grey-bg')}
        onClick={() => {
          if (!isPage) {
            onVisibleChange(false)
          } else {
            const params = new URLSearchParams(location.search)
            const fromPage = params.get('fromPage')
            if (fromPage) {
              navigate(fromPage.replace('/meinian', ''))
            } else {
              navigate('/home')
            }
          }
        }}
      >
        <Icon type="m-guanbi" />
      </div>
    }
    <div className={styles.mnImageDetailContent} style={{ height: getIpadVh() }}>
      <Spin spinning={loading}>
        <div className={styles.mnImageDetailContentWrap}>
          <OperationView
            imgInfoList={imgInfoList}
            currentImage={currentImage}
            setImgInfoList={setImgInfoList}
            queryParams={queryParams}
            innerIndex={innerIndex}
            setInnerIndex={setInnerIndex}
            setBanOperation={(val) => setBanOperation(val)}
            onInit={onInit}
            maxListLength={maxListLength}
            currentIndexInList={currentIndexInList}
            onOuterChange={onOuterChange}
            tabValue={tabValue}
            isAnnotate={isAnnotate}
            setIsAnnotate={setIsAnnotate}
          />
          <Spin spinning={infoLoading}>
            <InfoView imgInfoList={imgInfoList} isMove={isMove} />
          </Spin>
        </div>
        {tabValue === IMAGE_DETAIL_TAB.RECOMMEND && <Recommend tabValue={tabValue} imgInfoList={imgInfoList} />}
      </Spin>
    </div>
  </ImageDetailContext.Provider>
}
